import { createFileRoute, redirect } from "@tanstack/react-router";
import { getPlatformPrincipal } from "../lib/auth-session.ts";

export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: getPlatformPrincipal() ? "/dashboard" : "/login" });
  },
});
